import { USER_METHODS, USER_ROLES } from 'constants/constants';
import axiosClient from './axiosClient';

const userApi = {
  get: () => {
    const url = '/users/me';
    return axiosClient.get(url);
  },
  validateTwoFa: (data) => {
    const url = '/users/send-2fa-code';
    return axiosClient.post(url, data);
  },
  verifyTwoFA: (data) => {
    const url = '/users/validate-2fa-code';
    return axiosClient.post(url, data);
  },
  create: (data) => {
    const url = '/users';
    return axiosClient.post(url, data);
  },

  singup: (data) => {
    const url = '/users/signup';
    return axiosClient.post(url, data);
  },
  login: (data, config) => {
    const url = '/users/login';
    return axiosClient.post(url, data, config);
  },
  MFALoginGetOTP: (data) => {
    const url = '/users/MFALogin';
    return axiosClient.post(url, data);
  },
  edit: (formData) => {
    const url = '/users';
    return axiosClient.put(url, formData);
  },
  editPass: (data) => {
    const url = '/users/password';
    return axiosClient.put(url, data);
  },
  editSetting: (formData) => {
    const url = '/users/settings';
    return axiosClient.put(url, formData);
  },
  getTimezones: () => {
    const url = '/timezones';
    return axiosClient.get(url);
  },
  findUser: (params) => {
    const url = '/users/find';
    return axiosClient.get(url, { params });
  },
  getLanguage: () => {
    const url = '/languages';
    return axiosClient.get(url);
  },
  searchUser: (params) => {
    const url = '/users/search';
    return axiosClient.get(url, { params });
  },

  /**
   * @param {{page: number, rowPerPage?: number,
   * textSearch?: string,
   * userType?: string,
   * courseCentre?: string,
   * order?: string, orderBy?: string }} params
   * @returns {Promise<{data: Array<UserProps>, currentPage: number | null, totalItems: number, totalPage: number}>}
   */
  adminGetListUser: (params) => {
    const url = '/users';
    return axiosClient.get(url, { params });
  },

  advanceFilterListUser: async (data, { params }) => {
    return await axiosClient.post('/users/get-users', data, {
      params,
    });
  },

  adminGetListUserByPost: (data, { params, headers }) => {
    const url = '/users/get-users';
    return axiosClient.post(url, data, { params, headers });
  },

  adminLoginToUser: (id) => {
    const url = `/users/admin-login-user/${id}`;
    return axiosClient.post(url);
  },

  delete: (id) => {
    const url = `/users/${id}/permanently`;
    return axiosClient.delete(url);
  },
  getUserById: (id) => {
    const url = `/users/${id}`;
    return axiosClient.get(url);
  },
  requestResetPassword: (data) => {
    const url = '/users/forgot-password';
    return axiosClient.post(url, data);
  },
  resetPassword: (data, token) => {
    const url = '/users/forgot-password/verify';
    return axiosClient.post(url, data, { token });
  },
  getUserRole: () => {
    const url = '/user-roles';
    return axiosClient.get(url);
  },
  updateUserById: (id, data) => {
    const url = `/users/${id}`;
    return axiosClient.put(url, data);
  },
  checkImportUser: (data) => {
    const url = '/users/check-import-user';
    return axiosClient.post(url, data);
  },
  importUser: (data) => {
    const url = '/users/import-user';
    return axiosClient.post(url, data);
  },
  checkImport: (data) => {
    const url = '/users/check-import';
    return axiosClient.post(url, data);
  },
  importData: (data) => {
    const url = '/users/import';
    return axiosClient.post(url, data);
  },
  exportData: () => {
    const url = '/users/export';
    return axiosClient.get(url);
  },
  getChartDashboardAdmin: (params) => {
    const url = '/users/tracking-login-times';
    return axiosClient.get(url, { params });
  },
  getStackChartClasses: (params) => {
    const url = `/report/get-report-live-and-classroom`;
    return axiosClient.get(url, { params });
  },
  getTotalMostIntake: (params) => {
    const url = `/report/get-top-most-intakes`;
    return axiosClient.get(url, { params });
  },
  getTotalMostInstructor: (params) => {
    const url = '/report/get-top-most-instructors';
    return axiosClient.get(url, { params });
  },
  getDonutChartAssignments: (params) => {
    const url = `/report/get-report-assignments`;
    return axiosClient.get(url, { params });
  },
  getDonutChartTest: (params) => {
    const url = `/report/get-report-tests`;
    return axiosClient.get(url, { params });
  },
  getintakeschart: (params) => {
    const url = `/report/get-report-intakes`;
    return axiosClient.get(url, { params });
  },

  //SidebarCount
  getAdminSummary: (param) => {
    const url = `/report/get-collections-count?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  getInstructorSummary: (param) => {
    const url =
      `/report/get-instructor-summeries?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  getLearnerSummary: (param) => {
    const url = `/report/get-learner-summaries?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getGroup: (id, sort) => {
    const url = sort
      ? `/groups/get-discussions-by-course/${id}?sort=1`
      : `/groups/get-discussions-by-course/${id}`;
    return axiosClient.get(url);
  },

  getTopUserCourses: (id) => {
    const url = `/groups/get-discussion-top-users/${id}?type=course`;
    return axiosClient.get(url);
  },
  trackUser: (id) => {
    const url = `/course-users/${id}/learners`;
    return axiosClient.get(url);
  },
  sendInvoice: (id) => {
    const url = `/payments/send-invoice/${id}`;
    return axiosClient.get(url);
  },
  getUserByMail: (email) => {
    const url = `/users/get-user-by-email?email=${email}`;
    return axiosClient.get(url);
  },
  freeCoursePurchase: (data) => {
    const url = `/payments/enroll-learner-by-free-payment`;
    return axiosClient.post(url, data);
  },
};

export default userApi;

// user JSDoc type

/**
 * @typedef {Object} Timezone
 * @property {string} name - The name of the timezone.
 * @property {string} value - The value of the timezone.
 */

/**
 * @typedef {Object} UserTypeCheck
 * @property {string[]} roles - The roles of the user.
 * @property {string} _id - The ID of the user type.
 * @property {string} name - The name of the user type.
 * @property {string} defaultRole - The default role of the user type.
 * @property {string} key
 */

/**
 * @typedef {Object} UserType - this one json stringify data parse it and use it
 * @property {(keyof USER_ROLES)[]} roles
 * @property {keyof USER_ROLES} key
 * @property {keyof USER_ROLES} defaultRole
 * @property {"ACTIVE" | "DEAVTIVE"} status
 * @property {keyof USER_ROLES} systemRole
 * @property {{_id: string, parent?: string, name: string,  role: keyof USER_ROLES, routes: {method?: keyof typeof USER_METHODS, name?: keyof typeof USER_METHODS, route : [x: string]}[]  }[]} userTypeUnits
 * @property {{name: string, children: {name: string, routes:  }[] }[]} children
 * @property {string} name
 */

/**
 * @typedef {Object} UserProps
 * @property {string} userType
 * @property {CourseCentre[]} courseCentre - An array of course centre IDs.
 * @property {string} lastName - The last name of the user.
 * @property {string} status - The status of the user.
 * @property {boolean} twoFA - Whether two-factor authentication is enabled.
 * @property {boolean} sso - Whether two-factor authentication is enabled.
 * @property {number} points - The points of the user.
 * @property {boolean} online - Whether the user is online.
 * @property {number} unreadMessage - The number of unread messages.
 * @property {number} lastLogin - The timestamp of the last login.
 * @property {boolean} isPasswordChanged - Whether the password has been changed.
 * @property {string} _id - The ID of the user.
 * @property {string} firstName - The first name of the user.
 * @property {string} email - The email of the user.
 * @property {string} mainPage - The main page of the user.
 * @property {Timezone} timezone - The timezone of the user.
 * @property {import('./staffTypeApi').StaffTypeSchema} staffType
 * @property {Instructor} instructor
 * @property {string} language - The language ID of the user.
 * @property {UserTypeCheck} type - The type of the user.
 * @property {string} bio - The bio of the user.
 * @property {string} mobile - The mobile number of the user.
 * @property {string} countryCode - The country code of the user's mobile number.
 * @property {string} registrationBy - How the user was registered.
 * @property {string} salutation - The salutation of the user.
 * @property {string} createdAt - The creation timestamp of the user.
 * @property {string} fullName - The full name of the user.
 * @property {string[]} roles - The roles of the user.
 * @property {boolean} isOnboarded - The onboarded user.
 * @property {boolean} isStaffRequest - The roles of the user.
 * @property {string} learnerId - The roles of the user.
 */

/**
 * @typedef {Object} Instructor
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string} phone
 * @property {string} department
 * @property {string} designation
 * @property {string} qualification
 * @property {string} specialization
 * @property {string} experience
 * @property {string} courseCentre
 * @property {string} createdAt
 * @property {string} updatedAt
 * @property {string} gender
 * @property {string} title
 * @property {string} category
 * @property {string} nationality
 * @property {string} alternativeEmail
 * @property {string} mobilePhone
 * @property {string} linkedInUrl
 * @property {string} website
 * @property {string} companyName
 * @property {string} academicQualifications
 * @property {string} bio
 * @property {string[]|string} languagesSpoken
 * @property {{category: string, area: string}[]|string} areasOfSpecialization
 * @property {string[]|string} industryExperience
 * @property {string} icfCertification
 * @property {string} dietaryRestrictions
 * @property {string} facultyTracks
 * @property {string} recommendedBy
 * @property {string[]|string} assessmentsCertification
 * @property {string[]|string} simulationsCertification
 * @property {string[]|string} awards
 */
